import { RichTextField } from '@prismicio/client'
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react'
import { inlineImageSerializer, InlineTextContainer } from '../atoms/Atoms.tsx'

export interface ArticleProps {
  text: RichTextField
}

export default function InlineText(props: ArticleProps) {
  const inlineTextSerializer: JSXMapSerializer = {
    ...inlineImageSerializer,
    heading1: ({ children }) => wrapContentWithSpanElement(children, 'h1'),
    heading2: ({ children }) => wrapContentWithSpanElement(children, 'h2'),
    heading3: ({ children }) => wrapContentWithSpanElement(children, 'h3'),
    heading4: ({ children }) => wrapContentWithSpanElement(children, 'h4'),
    heading5: ({ children }) => wrapContentWithSpanElement(children, 'h5'),
    heading6: ({ children }) => wrapContentWithSpanElement(children, 'h6'),
  }

  const wrapContentWithSpanElement = (
    children: React.ReactNode,
    HeadingTag: keyof JSX.IntrinsicElements
  ) => {
    return (
      <HeadingTag>
        <span>{children}</span>
      </HeadingTag>
    )
  }

  return (
    <InlineTextContainer data-cy="inlineText">
      <PrismicRichText field={props.text} components={inlineTextSerializer} />
    </InlineTextContainer>
  )
}
